import {
	AntSelectEditableTagOptionsEntry,
	AntSelectPropsGeneric,
	AntSelectValue,
} from 'controls/react/ant/ant-select/types';
import { BaseOptionType } from '@rc-component/select/lib/Select';
import React from 'react';
import { CustomTagProps } from '@rc-component/select/lib/BaseSelect';
import { Tooltip } from 'antd';
import { SpaceHighlighter } from 'controls/ant/ant-select/components/space-highlighter/spaceHighlighter';
import { AntTag } from 'controls/react/ant/ant-select/antSelect';

export function useChipsRender<VT extends AntSelectValue, OptionType extends BaseOptionType>(
	props: AntSelectPropsGeneric<VT, OptionType>,
) {
	const { tagRender, ...rest } = props;

	const customTagRenderer = React.useCallback(
		(item: CustomTagProps) => {
			const element = props.options?.find(
				(element) => element.value === item.value,
			) as unknown as AntSelectEditableTagOptionsEntry<VT>;
			return (
				<AntTag onClose={item.onClose} closable={element?.removable !== undefined ? element.removable : true}>
					<Tooltip title={element?.tooltip ?? ''} zIndex={10010}>
						<SpaceHighlighter>{item.label}</SpaceHighlighter>
					</Tooltip>
				</AntTag>
			);
		},
		[props.options],
	);

	return {
		tagRender: (props.mode == 'tags' || props.mode == 'multiple') && tagRender == null ? customTagRenderer : tagRender,
		...rest,
	};
}
